<template>
  <div class="warehouseDelivery">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            v-for="(item, index) in tableData"
            :key="index"
            @click="gotoDetail(item)"
          >
            <template v-if="menuState == 4 || menuState == 5">
              <div class="list-item">
                {{ $t.warehouse.outboundNumber }}：{{ item.OutboundNumber }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.warehousingType }}：{{ item.OutboundCategoryStr }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.warehouseWorkNumber }}：{{ item.WarehouseWorkNumber }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.storageTime }}：{{ item.StorageTime }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.warehouseCode }}：{{ item.WarehouseCode }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.outBoundTime }}：{{ item.OutboundTime }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.goodsName }}：{{ item.ProductsName }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.billEnterprise }}：{{ item.CompanyName }}
              </div>
            </template>
            <template v-if="menuState == 3">
              <div class="list-item">
                {{ $t.warehouse.warehouseWorkNumber }}：{{ item.WarehouseWorkNumber }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.createTime }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.operation }}：{{ item.OperationTypeStr }}
              </div>
              <div class="list-item">{{ $t.warehouse.boxName }}：{{ item.BoxName }}</div>
              <div class="list-item">
                <span style="margin-right: 10px"
                  >{{ $t.warehouse.long }}：{{ item.Long }} cm</span
                >
                <span style="margin-right: 10px"
                  >{{ $t.warehouse.width }}：{{ item.Wide }} cm</span
                >
                <span>{{ $t.warehouse.height }}：{{ item.Height }} cm</span>
              </div>
              <div class="list-item">
                {{ $t.warehouse.goodsValue }}：{{ item.UnitPrice }}
              </div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.warehouse.warehouseWorkNumber }}：{{ item.WarehouseWorkNumber }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.outBoundState }}：{{ item.OutboundStateStr }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.warehouseNumber }}：{{ item.WarehouseNumber }}
              </div>
              <div class="list-item">{{ $t.warehouse.batch }}：{{ item.TotalBatch }}</div>
              <div class="list-item">
                {{ $t.warehouse.warehouseCode }}：{{ item.WarehouseCode }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.InStorageTime }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.goodsName }}：{{ item.ProductsName }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.billEnterprise }}：{{ item.CompanyName }}
              </div>
            </template>
            <template v-if="menuState == 1">
              <div class="list-item">
                {{ $t.warehouse.warehouseNumber }}：{{ item.WarehouseNumber }}
              </div>
              <div class="list-item">{{ $t.warehouse.batch }}：{{ item.TotalBatch }}</div>
              <div class="list-item">
                {{ $t.warehouse.warehouseCode }}：{{ item.WarehouseCode }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.warehousingTime }}：{{ item.AppointmentStorageTime }}
              </div>
              <div class="list-item">
                {{ $t.warehouse.goodsName }}：{{ item.ProductsName }}
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div v-if="menuState == 3">
          <div class="radio-label">{{ $t.warehouse.operateType }}</div>
          <van-radio-group v-model="operationType" direction="horizontal">
            <van-radio :name="1">{{ $t.warehouse.operation1 }}</van-radio>
            <van-radio :name="2">{{ $t.warehouse.operation2 }}</van-radio>
            <van-radio :name="3">{{ $t.warehouse.operation3 }}</van-radio>
          </van-radio-group>
        </div>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoWarehouseBill">{{
        $t.warehouse.addButton3
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "warehouseDelivery",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.warehouse.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.warehouse.tab2,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.warehouse.tab3,
          name: 3,
          count: 0,
        },
        {
          title: this.$t.warehouse.tab4,
          name: 4,
          count: 0,
        },
        {
          title: this.$t.warehouse.tab5,
          name: 5,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.warehouse.warehouseNumber,
          value: 1,
        },
        {
          text: this.$t.warehouse.warehouseCode,
          value: 2,
        },
        {
          text: this.$t.warehouse.billEnterprise,
          value: 3,
        },
        {
          text: this.$t.warehouse.batchRefNumber,
          value: 4,
        },
      ],
      operationType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    gotoWarehouseBill() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "warehouseBill",
        name: "warehouseBill",
        query: [],
      });
    },
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      localStorage.setItem("warehouseDeliveryDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "warehouseDeliveryDetail",
        name: "warehouseDeliveryDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.menuState == 3) {
        if (this.operationType || (this.beginTime && this.endTime)) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.beginTime && this.endTime) {
          return true;
        } else {
          return false;
        }
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.beginTime = "";
      this.endTime = "";
      this.operationType = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.menuState == 1) {
        this.searchTypeOptions = [
          {
            text: this.$t.warehouse.warehouseNumber,
            value: 1,
          },
          {
            text: this.$t.warehouse.warehouseCode,
            value: 2,
          },
          {
            text: this.$t.warehouse.billEnterprise,
            value: 3,
          },
          {
            text: this.$t.warehouse.batchRefNumber,
            value: 4,
          },
        ];
      }
      if (this.menuState == 2 || this.menuState == 4 || this.menuState == 5) {
        this.searchTypeOptions = [
          {
            text: this.$t.warehouse.warehouseNumber,
            value: 1,
          },
          {
            text: this.$t.warehouse.warehouseWorkNumber,
            value: 2,
          },
          {
            text: this.$t.warehouse.warehouseCode,
            value: 3,
          },
          {
            text: this.$t.warehouse.billEnterprise,
            value: 4,
          },
          {
            text: this.$t.warehouse.criteria,
            value: 5,
          },
        ];
      }
      if (this.menuState == 3) {
        this.searchTypeOptions = [
          {
            text: this.$t.warehouse.warehouseWorkNumber,
            value: 1,
          },
        ];
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 2 || this.menuState == 4 || this.menuState == 5) {
        param.WarehouseNumber = this.searchType == 1 ? this.searchText : "";
        param.WarehouseWorkNumber = this.searchType == 2 ? this.searchText : "";
        param.WarehouseCode = this.searchType == 3 ? this.searchText : "";
        param.CompanyName = this.searchType == 4 ? this.searchText : "";
        param.ProductSearchCriteria = this.searchType == 5 ? this.searchText : "";
      }
      if (this.menuState == 5) {
        param.OutboundType = 1;
        request = this.$api.storage.getOutboundList(param);
      } else if (this.menuState == 4) {
        param.OutboundType = 0;
        request = this.$api.storage.getOutboundList(param);
      } else if (this.menuState == 3) {
        param.WarehouseWorkNumber = this.searchType == 1 ? this.searchText : "";
        param.OperationType = this.operationType;
        request = this.$api.storage.getCargoOperationLogList(param);
      } else if (this.menuState == 2) {
        request = this.$api.storage.getAlreadyWarehousingList(param);
      } else {
        param.WarehouseNumber = this.searchType == 1 ? this.searchText : "";
        param.WarehouseCode = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
        param.GoodBatchReferenceNumber = this.searchType == 4 ? this.searchText : "";
        request = this.$api.storage.getPendingWarehousingList(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.warehouseDelivery {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
